import { Link } from 'react-router-dom';
import useCampaign from '../../../hooks/useCampaign';

export default function TeaCTA() {
  const { isActive } = useCampaign();

  return (
    <section className="relative py-20 sm:py-28 md:py-36 overflow-hidden" aria-labelledby="tea-cta-heading">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1394f6b3666bf1c6635a4d93d5751ece.jpg"
          alt="日本の茶園"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          width="1920"
          height="800"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        {isActive && (
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-medium rounded-full shadow-lg mb-6 animate-pulse">
            <i className="ri-fire-fill" aria-hidden="true"></i>
            <span>初回30%OFF キャンペーン実施中</span>
          </div>
        )}

        <h2 id="tea-cta-heading" className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em]">
          あなたのデスクに、<br />最高の一杯を
        </h2>
        <p className="text-base sm:text-lg text-white/70 font-extralight mb-8 sm:mb-12 tracking-wide max-w-2xl mx-auto">
          MeVER × Craft Teaのサブスクリプションで、<br className="hidden sm:block" />
          毎日のクリエイティブワークをもっと豊かに。
          {isActive && (
            <span className="block mt-2 text-orange-300">今なら初回配送分が30%OFFでお試しいただけます。</span>
          )}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <a
            href="https://crafttea.shop/"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 text-white text-sm sm:text-base font-light tracking-[0.1em] transition-colors whitespace-nowrap rounded-md cursor-pointer text-center ${
              isActive
                ? 'bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 font-medium shadow-lg'
                : 'bg-[#7B8C3E] hover:bg-[#6A7A35]'
            }`}
            aria-label="Craft Teaのサイトで申し込む（外部サイト）"
          >
            {isActive && <i className="ri-fire-fill mr-2" aria-hidden="true"></i>}
            {isActive ? 'キャンペーン価格で始める' : '今すぐ始める'}
          </a>
          <Link
            to="/atelier-folio"
            className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm sm:text-base font-light tracking-[0.1em] hover:bg-white/20 transition-colors whitespace-nowrap rounded-md border border-white/30 cursor-pointer text-center"
          >
            <i className="ri-tablet-line mr-2" aria-hidden="true"></i>
            Atelier Folio を見る
          </Link>
        </div>
      </div>
    </section>
  );
}
